import { FragmentSocialExportSettings } from '@app/modules/social-export/components/settings/FragmentSocialExportSettings';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { useSocialExportConnectedForStation } from '@app/modules/social-export/hooks/useSocialExportConnectedForStation';
import { socialExportPublishMessages } from '@app/modules/social-export/publish';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { SwitchElement } from 'react-hook-form-mui';

export function PlatformUploadFields({
  stationId,
  platform,
}: {
  stationId: string;
  platform: SocialPlatform;
}) {
  const enabled = useSocialExportConnectedForStation(stationId, platform);

  if (!enabled) {
    return null;
  }

  return (
    <Box my={0.5}>
      <SwitchElement
        name={`platformUpload.${platform.id}.enabled`}
        label={
          <Box>
            <FormattedMessage
              {...socialExportPublishMessages.sendToPlatform}
              values={{ platformName: platform.name }}
            />
          </Box>
        }
        switchProps={{
          size: 'small',
        }}
      />
      <Box>
        <FragmentSocialExportSettings
          platform={platform}
          fieldPrefix={`platformUpload.${platform.id}`}
        />
      </Box>
    </Box>
  );
}
